import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

import { PalletPrintData } from '../components/pallets/PalletPrint'

import { useDevanningStore } from './devanningStore'

import { PendingPallet } from '@/services/InboundV2Service'
import { useAuthStore } from '@/stores/authStore'

type PalletMode = 'quick' | 'mixed' | null

interface PalletState {
  palletModal: PalletMode
  printVisible: boolean
  pallet: PendingPallet | null
  palletId: number
  palletPrintData?: PalletPrintData
  dismantleVisible: boolean
  quickVisible: boolean
}

interface PalletActions {
  closePrintDialog: () => void
  closeDismantleConfirm: () => void
  showPrintDialog: (pallet: PendingPallet) => void
  showDismantleContrim: (palletId: number) => void
  showQuickConfirm: () => void
  closeQuickConfirm: () => void
}

type PalletStore = PalletState & PalletActions

const initialState: PalletState = {
  palletModal: null,
  printVisible: false,
  dismantleVisible: false,
  pallet: null,
  palletId: 0,
  quickVisible: false
}

export const usePalletStore = create<PalletStore>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        closePrintDialog: () => {
          set({
            printVisible: false,
            pallet: null
          })
        },
        closeDismantleConfirm: () => {
          set({
            dismantleVisible: false,
            palletId: 0
          })
        },
        showPrintDialog: (pallet: PendingPallet) => {
          const masterBill = useDevanningStore.getState().masterBill
          const user = useAuthStore.getState().user
          console.log(pallet)
          set({
            printVisible: true,
            palletPrintData: {
              customerNumber: masterBill?.customerNumber,
              houseBlNumber: pallet.houseBlNumber,
              devanDate: masterBill?.devanDate || '',
              palletCode: pallet.palletCode,
              total: pallet.totalBoxes,
              cargoMarks: pallet.cargoMarks,
              notes: pallet.marksCount > 1 ? '混' : '',
              printUser: user?.name || user?.nick || '名無し'
            }
          })
        },
        showQuickConfirm: () => {
          set({
            palletModal: 'quick',
            quickVisible: true
          })
        },
        showDismantleContrim: (palletId: number) => {
          set({
            dismantleVisible: true,
            palletId: palletId
          })
        },
        closeQuickConfirm: () => {
          set({
            palletModal: null,
            quickVisible: false
          })
        }
      }),
      {
        name: 'devanning-storage',
        partialize: (state) => ({
          pallet: state.pallet
        })
      }
    )
  )
)

export const usePalletState = () => {
  const palletModal = usePalletStore((state) => state.palletModal)
  const quickVisible = usePalletStore((state) => state.quickVisible)
  const printVisible = usePalletStore((state) => state.printVisible)
  const dismantleVisible = usePalletStore((state) => state.dismantleVisible)
  const pallet = usePalletStore((state) => state.pallet)
  const palletId = usePalletStore((state) => state.palletId)
  const palletPrintData = usePalletStore((state) => state.palletPrintData)

  return {
    palletModal,
    printVisible,
    dismantleVisible,
    pallet,
    palletId,
    palletPrintData,
    quickVisible
  }
}

export const usePalletActions = () => {
  const showQuickConfirm = usePalletStore((state) => state.showQuickConfirm)
  const closeQuickConfirm = usePalletStore((state) => state.closeQuickConfirm)
  const closePrintDialog = usePalletStore((state) => state.closePrintDialog)
  const closeDismantleConfirm = usePalletStore(
    (state) => state.closeDismantleConfirm
  )
  const showPrintDialog = usePalletStore((state) => state.showPrintDialog)
  const showDismantleContrim = usePalletStore(
    (state) => state.showDismantleContrim
  )
  return {
    showQuickConfirm,
    closeQuickConfirm,
    closePrintDialog,
    closeDismantleConfirm,
    showPrintDialog,
    showDismantleContrim
  }
}
